/* @flow strict */

import * as React from 'react';
import Loader from '/client/src/components/Loader';
import CollaboratorPageTopSection from './topSection';
import SimpleSelect from '/client/src/components/forms/select';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { DELETE, PUT } from '/client/src/api/';
import { timeerOffModal } from '/client/src/constants/';
import _ from 'lodash';

type PropsType = {
  eventId: number | string,
  isNew?: boolean,
  onHandleChangeStepNavBar?: (number) => void,
  history?: {
    push: (string) => void
  },
  defaultContainerContext: {
    handleShowSystemDialog: () => void,
    profileCurrent: {
      id: string
    }
  }
};

class CollaboratorPage extends React.Component<PropsType> {
  props: PropsType;

  static contextType = EventDetailContainerContext;

  state = {
    colbrts: [],
    isPending: false
  };

  handleLoaded = async (error: Error, response: any) => {
    if (!error) {
      const clbrList = _.get(response, 'data.result', []);
      const filteredClbrList = _.filter(clbrList, (c: {}): {} => {
        return !c.is_owner;
      });
      const owner = _.find(clbrList, (c: {}): {} => {
        return c.is_owner === true;
      });

      this.setState({
        colbrts: filteredClbrList,
        owner: owner.collaborator
      });
    }
  };

  pendingComtroll = (status: boolean) => {
    this.setState({
      isPending: status
    });
  };

  handleRemove = (eventId: string | number, email: string) => {
    const { handleShowSystemDialog } = this.props.defaultContainerContext;

    handleShowSystemDialog(true, {
      systemDialogType: 'warning',
      systemDialogTitle: 'Hmmm...',
      systemDialogContent: 'Remove the collaborator?',
      systemDialogCallback: async () => {
        try {
          this.pendingComtroll(true);
          await DELETE(`/api/v1/1/events/${eventId}/collaborators?email=${encodeURIComponent(email)}`);

          const colbrts = _.filter(this.state.colbrts, (item: {}): {} => {
            return item.collaborator.email !== email;
          });

          this.setState({ colbrts }, () => {
            handleShowSystemDialog(true, {
              systemDialogType: 'success',
              systemDialogTitle: 'Great!',
              systemDialogContent: 'Successfull remove'
            });

            this.pendingComtroll(false);

            setTimeout(() => {
              handleShowSystemDialog(false);
            }, timeerOffModal);
          });
        } catch (e) {
          console.log(e);
          console.log('Can\'t remove collaborator');

          this.pendingComtroll(false);

          handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Oops',
            systemDialogContent: 'Can\'t remove collaborator'
          });
        }
      }
    });
  };

  handleAddCb = (data: {}, permission: boolean) => {
    this.setState({
      colbrts: [
        ...this.state.colbrts,
        {
          collaborator: data,
          event_id: this.props.eventId,
          is_owner: true,
          permission
        }
      ]
    });
  };

  handleUpdateCb = async (eventId: string | number, email_address: string, permission: string) => {
    const { handleShowSystemDialog } = this.props.defaultContainerContext;

    try {
      this.pendingComtroll(true);
      await PUT(`/api/v1/1/events/${eventId}/collaborators`,
        {
          email_address,
          permission
        });
      const newColbrts = this.state.colbrts.map(x => {
        return x.collaborator.email === email_address ? { ...x, permission } : x;
      });

      this.setState({ colbrts: newColbrts }, () => {
        handleShowSystemDialog(true, {
          systemDialogType: 'success',
          systemDialogTitle: 'Great!',
          systemDialogContent: 'Successfull updated'
        });
      });
      this.pendingComtroll(false);

      setTimeout(() => {
        handleShowSystemDialog(false);
      }, timeerOffModal);
    } catch (e) {
      console.error(e);
      console.error('Can\'t update collaborator');

      this.pendingComtroll(false);

      handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Oops',
        systemDialogContent: 'Can\'t update collaborator'
      });
    }
  }

  render(): React.Element<'div'> {
    const { colbrts, owner, isPending } = this.state;
    const { eventId, isNew, defaultContainerContext} = this.props;
    const isReadonlyPermission = _.toString(_.get(owner, 'id', '')) !== _.toString(_.get(defaultContainerContext, 'profileCurrent.id', ''));

    return (
      <>
      { (!isReadonlyPermission || isNew) &&
        <CollaboratorPageTopSection
          eventId={eventId}
          handleAddCb={this.handleAddCb}
          pendingComtroll={this.pendingComtroll}
        />
      }
        <div className={`panel panel-default panel-page panel-collaborators ${isPending ? 'csspinner' : ''}`}>
        { isReadonlyPermission &&
          <div className="panel-heading panel-heading-color2">
          <div className="panel-title">
            <span>Collaborate</span>
          </div>
        </div>
        }
          <div className="panel-body" style={{ minHeight: '500px', position: 'relative' }}>
            <div className="container-fluid">
              <div className="collaborators">
              { isReadonlyPermission && owner &&
               <div className="form-group">
               <label>
                 Event Owner
               </label>
               <div className="row collaborator">
                          <div className="col-sm-7 collaborator-info">
                            <div className="user-icon">
                              <i>
                                {owner.first_name.substr(0, 1)}{owner.last_name.substr(0, 1)}
                              </i>
                            </div>
                            <div style={{ width: '35%' }}>
                                <b>{owner.first_name} {owner.last_name}</b>
                            </div>
                            <div>
                              <b data-bind="text:data.email">{owner.email}</b>
                            </div>
                          </div>
                          </div>
               </div>
              }
                <div className="form-group">
                  <label>
                    Current Collaborators
                  </label>

                  <Loader
                    url={`/api/v1/1/events/${eventId}/collaborators`}
                    onLoaded={this.handleLoaded}
                  >
                    {_.map(colbrts, (ci: {}, ck: number): React.Element<'div'> => {
                      return (
                        <div className="row collaborator" key={`CollaboratorPage-${ck}`}>
                          <div className="col-sm-7 collaborator-info">
                            <div className="user-icon">
                              <i>
                                {ci.collaborator.first_name.substr(0, 1)}{ci.collaborator.last_name.substr(0, 1)}
                              </i>
                            </div>

                            <div style={{ width: '35%' }}>
                              {!!ci.collaborator.status ?
                                <b>{ci.collaborator.first_name} {ci.collaborator.last_name}</b> :
                                <b>Waiting on confirmation</b>
                              }
                            </div>
                            <div>
                              <b data-bind="text:data.email">{ci.collaborator.email}</b>
                            </div>
                          </div>
                          { (!isReadonlyPermission || isNew) &&
                          <>
                          <div className="col-sm-3 collaborator-m">
                            <SimpleSelect
                              value={ci.permission}
                              callBack={(e: any) => this.handleUpdateCb(ci.event_id, ci.collaborator.email, e.target.value)}
                              items={[
                                {
                                  label: 'Can edit and view your event',
                                  value: 'Write'
                                },
                                {
                                  label: 'Can view your event',
                                  value: 'Read'
                                }
                              ]}
                            />
                          </div>

                          <div className="col-sm-2">
                            <div className="input-group">
                              <div
                                className="input-group-addon"
                                onClick={() => {
                                  this.handleRemove(ci.event_id, ci.collaborator.email);
                                }}
                              >
                                <i className="icon icon-trash" />
                              </div>
                              <div className="form-control-static">
                                <label className="save-state">
                                  <i className="icon icon-check" />
                                  <span>saved!</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          </>
                    }
                        </div>
                      );
                    })}

                    {(isNew && !_.size(colbrts)) &&
                      <>
                        <div className="buttons text-center" style={{ margin: '100px 0' }}>
                          <button
                            className="btn btn-gray"
                            style={{ color: '#aaa', position: 'relative', fontSize: '18px' }}
                            onClick={() => {
                              this.props.history.push(`/events/new/${eventId}/share`);
                              this.props.onHandleChangeStepNavBar(4);
                            }}
                          >
                            <span>I will add collaborators later</span>
                            <i
                              style={{ position: 'absolute', right: '20px', top: '6px', fontSize: '24px' }}
                              className="icon icon-angle-right"
                            />
                          </button>
                          <p style={{ position: 'absolute', width: '100%', bottom: '30px' }} className="gary">
                            Collaborators won't have the ability to change the payment account attached to this event</p>
                        </div>
                      </>
                    }
                  </Loader>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default CollaboratorPage;
